import * as React from 'react'
import { Marker } from '@urbica/react-map-gl'
import styled from 'styled-components'
import VCMarker from './assets/Marker.png'

const MarkerCounter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-size: 10px;
  font-weight: 600;
  padding: 0;
  color: #ff0082;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  left: -10px;
  top: -12px;
  z-index: 1;
`

export default ({ longitude, latitude, pointCount }) => (
  <Marker longitude={longitude} latitude={latitude} offsetTop={-55}>
    <img
      src={VCMarker}
      alt="Marker VC"
      style={{ height: '55px', cursor: 'pointer' }}
    />
    <MarkerCounter className="marker-counter">{pointCount}+</MarkerCounter>
  </Marker>
)
